export const releaseNotificationConstants = {
	ReleaseNotificationSettingGetRequest: "RELEASE_NOTIFICATION_SETTING_GET_STARTED",
	ReleaseNotificationSettingGetSuccess: "RELEASE_NOTIFICATION_SETTING_GET_COMPLETED",
	ReleaseNotificationSettingGetFailure: "RELEASE_NOTIFICATION_SETTING_GET_FAILED",

	ReleaseNotificationSettingUpdateRequest: "RELEASE_NOTIFICATION_SETTING_UPDATE_STARTED",
	ReleaseNotificationSettingUpdateSuccess: "RELEASE_NOTIFICATION_SETTING_UPDATE_COMPLETED",
	ReleaseNotificationSettingUpdateFailure: "RELEASE_NOTIFICATION_SETTING_UPDATE_FAILED",
}
